import { render, staticRenderFns } from "./kpi-card.vue?vue&type=template&id=e9932054&scoped=true&"
import script from "./kpi-card.component.ts?vue&type=script&lang=ts&"
export * from "./kpi-card.component.ts?vue&type=script&lang=ts&"
import style0 from "./kpi-card.vue?vue&type=style&index=0&id=e9932054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9932054",
  null
  
)

export default component.exports